import { Breadcrumbs } from "@mui/material";
import { Link } from "react-router-dom";
import { ProfileCardProps } from "../../interfaces/components";
import BreadCrumbs from "../BreadCrumbs";
import styles from "./profileCard.module.scss";

const ProfileCard = ({
    children,
    className,
    breadCrumbs,
    rightOptions,
    compact
}: ProfileCardProps) => {
    return(
        <div className={`${styles.profileCardContainer} ${compact ? styles.compactContainer : ""}`}>
            <div className={styles.breadCumbsContainer}>
                {
                    breadCrumbs && <BreadCrumbs options={breadCrumbs} />
                }
                {
                    rightOptions && rightOptions
                }
            </div>
            <div className={`${styles.children} ${compact ? styles.compact : ""} ${className}`}>
                {children}
            </div>
        </div>
    )
};

export default ProfileCard;